(() => {
  // src/block-wrapper.ts
  (() => {
    window.HotelCollection = window.HotelCollection || {};
    if (window.HotelCollection.blockScrollRevealInit) return;
    window.HotelCollection.blockScrollRevealInit = true;
    const run = (scope) => {
      var _a, _b;
      const root = scope || document;
      (_b = (_a = window.HotelCollection).initScrollReveal) == null ? void 0 : _b.call(
        _a,
        root.querySelectorAll(".block"),
        "block--will-animate",
        "block--revealed",
        0,
        "0px 0px -20% 0px"
      );
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => run());
    } else {
      run();
    }
    document.addEventListener("shopify:section:load", (e) => run(e.target));
  })();
})();
